<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article class="wrapper wrapper-content main-column full-column">
        <!-- ViewTitleBox -->
          <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_notice_on.png" alt="">
                {{$t('noticeListStr')}}
            </h1>
            <span class="info-right">
                <span @click="$router.push({ name: 'NoticeSetting' })" class="btn btn-secondary">{{$t('noticeSettingTitle')}}</span>
            </span>
          </div>
          <!-- /ViewTitleBox -->
          <section class="animated fadeInRight">
            <div class="ibox">
            <div class="ibox-content flex-option">
              <div class="ibox-child cursor" v-if="!Object.values(getCurrentNotices)[0]">
                {{$t('stillNotNoticeStr')}}
              </div>
              <div class="ibox-child cursor" v-for="(notice, index) in getNotices" :key="notice.id" @click="getDetail(notice)" v-if="Object.values(getCurrentNotices)[0] && notice.type">
                <notice-item :text="setText(notice)" :type="setType(Object.keys(notice.type)[0])" :img="setImg(Object.keys(notice.type)[0])" :time="preparedTime(notice.createdAt)" v-observe-visibility="visibilityChanged" :accessKey="index"/>
              </div>
            </div>
          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {i18n, liteMode} from '@/main.js'
import moment from 'moment'
import CommonJs from '@/js/common'
import NoticeItem from '@/components/Notice/NoticeItem'
export const $t = this.$t

export default {
  name: 'NoticeList',
  mixins: [CommonJs],
  components: {
    NoticeItem
  },
  data: function () {
    return {
      tag: {
        name: 'Notice',
        src: 'notice',
        status: 'progress'
      },
      notices: {},
      time: '',
      noticeCount: 30
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'NoticeList'
    },
    ...mapGetters([
      'getCurrentUserInfo'
    ]),
    ...mapGetters('notices/', [
      'getCurrentNotices',
      'getLatestNoticesByUserId'
    ]),
    ...mapGetters('groups/', [
      'getGroups'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    checkLanguage () {
      return i18n.locale
    },
    noticeCreatedObjective () { return this.$t('noticeCreatedObjective') },
    noticeCreatedKeyResult () { return this.$t('noticeCreatedKeyResult') },
    noticeCreated1on1 () { return this.$t('noticeCreated1on1') },
    noticeCreatedRTFB () { return this.$t('noticeCreatedRTFB') },
    noticeUpdatedObjective () { return this.$t('noticeUpdatedObjective') },
    noticeUpdatedKeyResult () { return this.$t('noticeUpdatedKeyResult') },
    noticeUpdated1on1 () { return this.$t('noticeUpdated1on1') },
    noticeUpdatedRTFB () { return this.$t('noticeUpdatedRTFB') },
    noticeDeletedObjective () { return this.$t('noticeDeletedObjective') },
    noticeDeletedKeyResult () { return this.$t('noticeDeletedKeyResult') },
    noticeDeleted1on1 () { return this.$t('noticeDeleted1on1') },
    noticeDeletedRTFB () { return this.$t('noticeDeletedRTFB') },
    noticeCommentedOnObjective () { return this.$t('noticeCommentedOnObjective') },
    noticeCommentedOnKeyResult () { return this.$t('noticeCommentedOnKeyResult') },
    noticeCommentedOn1on1 () { return this.$t('noticeCommentedOn1on1') },
    noticeCommentedOnRTFB () { return this.$t('noticeCommentedOnRTFB') },
    noticeCompletedObjective () { return this.$t('noticeCompletedObjective') },
    noticeCompletedKeyResult () { return this.$t('noticeCompletedKeyResult') },
    noticeMemberOfGroup () { return this.$t('noticeMemberOfGroup') },
    noticeRequested1on1 () { return this.$t('noticeRequested1on1') },
    noticeLiked () { return this.$t('noticeLiked') },
    noticeMessaged () { return this.$t('noticeMessaged') },
    noticeDateFormat () { return this.$t('noticeDateFormat') },
    noticeGroupDeleted () { return this.$t('noticeGroupDeleted') },
    noticeConfigUser () { return this.$t('noticeConfigUser') },
    noticeConfigGroup () { return this.$t('noticeConfigGroup') },
    noticeUnavailable () { return this.$t('noticeUnavailable') },
    noticeAvailable () { return this.$t('noticeAvailable') },
    noticeRemovedGroup () { return this.$t('noticeRemovedGroup') },
    noticeNewVersionReleased () { return this.$t('noticeNewVersionReleased') },
    getNotices () {
      const notices = this.getCurrentNotices
      const noticesForShow = []
      for (const noticeKey in notices) {
        if (liteMode) {
          if (notices[noticeKey].noticeKey.includes('Objective') || notices[noticeKey].noticeKey.includes('KeyResult')) {
            continue
          }
        }
        noticesForShow.push(notices[noticeKey])
      }
      this.updateLastNotice()
      return noticesForShow.reverse().slice(0, this.noticeCount)
    }
  },
  mounted () {
    if (this.getNotices.length > 0) {
      this.updateLastNotice(this.getNotices[0].createdAt / 1000)
    }
  },
  methods: {
    ...mapActions('notices/', {
      setLastNotice: 'SET_LAST_NOTICE'
    }),
    updateLastNotice: function () {
      if (this.getLatestNoticesByUserId.length > 0) {
        let latestNotice = this.getLatestNoticesByUserId[0].notice.createdAt / 1000
        this.setLastNotice(latestNotice)
      }
    },
    getDetail: function (value) {
      console.log('notice value', value)
      if (value.type.group) {
        if (value.noticeKey === 'noticeRemovedGroup') { return }
        this.$router.push({ name: 'GroupList', params: { item: value.type } })
      } else if (value.type['1on1requests']) {
        this.$router.push({ name: 'OneRequestRece', params: { item: value.type } })
      } else if (value.type['comments']) {
        console.log('trace:::', value)
        this.$router.push({
          name: 'User',
          params: {
            userId: value.noticeOpt.targetOwner || '',
            item: {
              [value.noticeOpt.targetType]: value.noticeOpt.targetId
            },
            noticeKey: value.noticeKey,
            noticeType: value.type ? Object.keys(value.type)[0] : null
          }
        })
      } else {
        this.$router.push({ name: 'User', params: { userId: value.userId, item: value.type, noticeKey: value.noticeKey } })
      }
    },
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.noticeCount - 1) {
        this.noticeCount += 30
        this.$forceUpdate()
      }
    },
    setText (value) {
      let contentText
      if (value.noticeOpt) {
        let noticeUserName = this.getUserInfoById(value.noticeOpt.userId || value.userId).userName || ''
        if (value.noticeOpt.userName && value.noticeOpt.ymd) {
          let date
          let dateFormat = []
          dateFormat = value.noticeOpt.ymd.split('-')
          if (this.checkLanguage === 'en') dateFormat.reverse()
          date = dateFormat.join('/')
          contentText = this[value.noticeKey].replace('{$user}', noticeUserName).replace('{$date}', date)
        } else if (value.noticeOpt.userName && value.noticeOpt.commentKey) {
          contentText = this[value.noticeKey].replace('{$user}', noticeUserName)
        } else if (value.noticeOpt.userName && !value.noticeOpt.ymd && !value.noticeOpt.userId) {
          contentText = this[value.noticeKey].replace('{$user}', noticeUserName)
        } else if (value.noticeOpt.userName && !value.noticeOpt.ymd) {
          contentText = this[value.noticeKey].replace('{$user}', noticeUserName)
        } else if (value.noticeOpt.groupName) {
          if (this.getGroups[Object.values(value.type)[0]]) {
            contentText = this[value.noticeKey].replace('{$group}', this.getGroups[Object.values(value.type)].groupName)
          } else {
            contentText = this[value.noticeKey].replace('{$group}', value.noticeOpt.groupName)
          }
        } else if (value.noticeOpt.latestVersion) {
          contentText = this[value.noticeKey].replace('{$version}', value.noticeOpt.latestVersion)
        }
      } else {
        contentText = value.contentText
      }
      return contentText
    },
    setType (type) {
      switch (type) {
        case 'group':
          return 'グループ'
        case 'keyresults':
        case 'objectives':
          return 'OKR'
        case 'system':
          return 'システム'
        case 'comments':
          return 'コメント'
        case 'rtfbs':
          return 'FB Request'
        default:
          return '1on1'
      }
    },
    setImg (type) {
      switch (type) {
        case 'group':
          return 'static/img/notice/group.png'
        case 'keyresults':
        case 'objectives':
          return 'static/img/notice/okr.png'
        case 'system':
          return 'static/img/notice/okr.png'
        case 'comments':
          return 'static/img/assets/comment.png'
        case 'rtfbs':
          return 'static/img/notice/rtfb.png'
        default:
          return 'static/img/notice/1on1.png'
      }
    },
    preparedTime (time) {
      if (this.checkLanguage === 'zh_tr') {
        moment.locale('zh_tw')
      } else {
        moment.locale(this.checkLanguage)
      }
      let timestamp = moment(time).fromNow()
      return timestamp
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column;
  }
  /* .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  } */
</style>



// WEBPACK FOOTER //
// src/views/notice/NoticeList.vue